import { BoardColumn } from './BoardColumn';
import { BOARD_COLUMNS } from '../../lib/work-management-helpers';
import type { BoardViewResponse } from '@localagent/sdk';

interface KanbanBoardProps {
  board: BoardViewResponse;
}

/**
 * Layout only. Drag-to-transition is removed — a ticket moves lane by asking the
 * docked agent (app-shell ADR-013).
 */
export function KanbanBoard({ board }: KanbanBoardProps) {
  return (
    <div className="flex gap-3 overflow-x-auto pb-4">
      {BOARD_COLUMNS.map((column) => {
        const col = board.columns.find((c) => c.state === column);
        const tickets = col?.tickets ?? [];

        return <BoardColumn key={column} state={column} tickets={tickets} />;
      })}
    </div>
  );
}
